import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function EmotionalHook() {
  return <section className="bg-[#9B4D4D] py-16 text-white text-center px-4" data-id="element-37">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto" data-id="element-38">
        <h2 className="text-3xl md:text-4xl font-serif font-medium mb-6 leading-relaxed" data-id="element-39">
          Lo que realmente está pasando en tu cuerpo
        </h2>

        <div className="space-y-4 text-lg font-light text-white/90 mb-10" data-id="element-40">
          <p data-id="element-41">
            Cuando el estrés se prolonga, tu sistema nervioso baja su umbral de
            alerta.
          </p>
          <p className="font-medium text-white text-xl" data-id="element-42">
            Lo que antes era excepción… se vuelve estado base.
          </p>

          <div className="bg-white/10 rounded-xl p-5 text-left max-w-lg mx-auto border border-white/10" data-id="element-43">
            <p className="font-bold text-[#C4973B] mb-3 uppercase tracking-wider text-xs" data-id="element-44">
              Tu cuerpo deja de distinguir entre:
            </p>
            <div className="grid grid-cols-2 gap-2" data-id="element-45">
              {['Un peligro real', 'Un mensaje sin responder', 'Una conversación incómoda', 'Un recuerdo del pasado'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-46">
                  <div className="h-1.5 w-1.5 rounded-full bg-[#C4973B]" data-id="element-47" />
                  <span className="text-sm" data-id="element-48">{item}</span>
                </div>)}
            </div>
          </div>

          <p className="font-bold text-white text-xl pt-4" data-id="element-49">
            No estás fallando. Tu cuerpo necesita una señal clara de seguridad.
          </p>
        </div>

        <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#C4973B] text-white font-bold py-4 px-8 rounded-full shadow-lg hover:bg-[#B08632] hover:scale-105 transition-all text-lg" data-id="element-50">
          Quiero calmar mi sistema nervioso
          <ArrowRight className="h-5 w-5" data-id="element-51" />
        </a>
      </motion.div>
    </section>;
}